<div class="ui basic segment" [class.loading]="isLoading">
    <app-header [title]="title" [back]="true" backRoute="/settings/custom-fields/fields"></app-header>

    <div class="ui layout">
        <div>
            <ui-banner variant="warning" class="margin-bottom-4">
                <p>
                    {{ 'settings.custom-fields.fieldSelectionBanners.AvoidRequestingSensitiveInformation' | translate }}
                </p>
            </ui-banner>

            <div class="ui segment">
                <app-segment-header
                    title="{{ 'settings.custom-fields.fieldInformation' | translate }}"
                ></app-segment-header>
                <!-- Banner if field group is under job & pay -->
                <ui-banner
                    *ngIf="fieldGroup.component === 'job_and_pay' && fieldGroup.isCustom"
                    variant="info"
                    class="margin-y-2"
                >
                    <p>{{ 'settings.custom-fields.fieldSelectionBanners.jobAndPayAndCustom' | translate }}</p>
                </ui-banner>

                <ui-banner
                    *ngIf="fieldGroup.component === 'personal' && !fieldGroup.isCustom"
                    variant="info"
                    class="margin-y-2"
                >
                    <p>
                        {{
                            'settings.custom-fields.fieldSelectionBanners.personalNotCustom'
                                | translate
                                    : {
                                          fieldGroupName: fieldGroup.name,
                                      }
                        }}
                    </p>
                </ui-banner>

                <ui-banner
                    *ngIf="fieldGroup.component === 'job_and_pay' && !fieldGroup.isCustom"
                    variant="info"
                    class="margin-y-2"
                >
                    <p>
                        {{
                            'settings.custom-fields.fieldSelectionBanners.jobAndPayNotCustom'
                                | translate
                                    : {
                                          fieldGroupName: fieldGroup.name,
                                      }
                        }}
                    </p>
                </ui-banner>

                <!-- Banner to be displayed on edit page -->
                <ui-banner *ngIf="onEditCustomFieldPage" variant="info" class="margin-y-2">
                    <p>{{ 'settings.custom-fields.cannotChangeFieldTypeNotice' | translate }}</p>
                </ui-banner>

                <app-field-details-form
                    #detailsForm
                    [field]="field"
                    [(group)]="fieldGroup"
                    [disableFieldType]="onEditCustomFieldPage"
                    [preselectDefaultAdmin]="!onEditCustomFieldPage"
                    [dataFieldOptionState]="dataFieldOptionState"
                ></app-field-details-form>
            </div>

            <!-- Buttons -->
            <ng-container *ngIf="!onEditCustomFieldPage">
                <div style="display: flex; justify-content: flex-end">
                    <ui-button (click)="onSave()" type="primary"
                        >{{ 'settings.custom-fields.saveAndAssign' | translate }}
                        <mat-icon svgIcon="chevronRight"></mat-icon
                    ></ui-button>
                </div>
            </ng-container>

            <ng-container *ngIf="onEditCustomFieldPage">
                <div style="display: flex; justify-content: flex-end">
                    <ui-button (click)="onSave()" type="primary">{{ 'save' | translate }} </ui-button>
                </div>
            </ng-container>
        </div>
    </div>
</div>
